import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Injectable()
export class BaseValidator {

  static emailValidation(control: AbstractControl) {
    if (control.touched && control.dirty) {
      if (control.value === '') {
        return null;
      } else {
        return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(control.value) ? null : { emailValidator: true };
      }
    }
  }

  static numericValidation(control: AbstractControl) {
    if (control.dirty) {
      if (control.value === '') {
        return null;
      } else {
        return /\d+/.test(control.value) ? null : { numericValidation: true };
      }
    }
  }

  static isDocument(filename) {
    return /\.(txt|doc|docx|rtf|pdf|ppt|pptx|odt)$/i.test(filename);
  }

  static isImage(filename) {
    return /\.(jpe?g|png|gif|bmp)$/i.test(filename);
  }

  static isVideo(filename) {
    return /\.(mp4)$/i.test(filename);
  }

  static isAudio(filename) {
    return /\.(mp3)$/i.test(filename);
  }

  static checkMaxFileSize(size) {
    return size / 1024 / 1024 > 100;
  }

  static isEmptyArray(arr): boolean {
    return JSON.stringify(arr) === '[]';
  }

  static isEmptyObj(obj): boolean {
    return JSON.stringify(obj) === '{}';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/validator/base.service.ts